import { defineComponent, h } from 'vue';
import { Modal } from '@/ui/components/Modal';
import { createHubspotForm } from '@/services/hubspot';
import { getLocale } from '@/ui/i18n/i18n';
import { user } from '@/ui/auth/auth';
import { COUNTRY_CODE_GERMANY } from '@/_legacy/constants';

interface HubspotContactSalesModalProps {
  active: boolean;
}

export const HubspotContactSalesModal = defineComponent<HubspotContactSalesModalProps>({
  props: ['active'],
  setup(props, context) {
    const formId = () => {
      const locale = getLocale();

      if (locale === COUNTRY_CODE_GERMANY.toLowerCase()) {
        return !user.value.organization.subscription
          ? '4a3bdbe8-5ad0-4cff-8299-65d15230a311'
          : '83df25f3-8ce3-4db6-b6eb-17283979b03e';
      }

      return !user.value.organization.subscription
        ? '04537eb0-c048-41b6-92a8-600e4442ca4b'
        : '96a4d0c5-a102-41a7-87f2-9e707694e450';
    };

    return function render() {
      createHubspotForm({
        portalId: process.env.VUE_APP_HUBSPOT_PORT_ID as string,
        formId: formId(),
        target: '#hub-spot-form',
      });

      return h(Modal, {
        props: {
          active: props.active,
        },
        on: {
          close: () => {
            context.emit('close');
          },
        },
      }, [
        h('div', { attrs: { id: 'hub-spot-form' } }),
      ]);
    };
  },
});
